import { useDispatch, useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton } from 'components/common';

interface Props {
  type: 'expired' | 'expiring';
  unreviewedCompletions: number;
  updateCompletions: () => Promise<void>;
}

const MyTeamReviewCompletionsMarkReviewedAll = ({
  type,
  unreviewedCompletions,
  updateCompletions
}: Props) => {
  const { dispatch } = useDispatch();

  const {
    messages,
    pageState: { supervisor },
    supervisorUnreviewedItems,
    user
  } = useReduxState();

  const setAsReviewed = async () => {
    await api.put(`/admin/supervisors/${user.id}/unreviewed-items`, { type });
    await updateCompletions();

    const unreviewedItems = supervisorUnreviewedItems - unreviewedCompletions;
    dispatch.setSupervisorUnreviewedItems(unreviewedItems);
    dispatch.updatePageState({
      supervisor: { ...supervisor, unreviewedItems }
    });
    return true;
  };

  return (
    <ConfirmButton
      actionText={messages.commonMarkAsReviewed}
      buttonIcon="check-circle"
      buttonIsDropdown={true}
      buttonStyle={{ whiteSpace: 'nowrap' }}
      buttonText={messages.myTeamReviewMarkAll}
      category="success"
      confirmTitle={messages.myTeamReviewMarkAll}
      confirmText={messages.myTeamReviewMarkAllConfirm}
      onConfirm={setAsReviewed}
      successMessage={messages.myTeamReviewMarkAllSuccess}
    />
  );
};

export default MyTeamReviewCompletionsMarkReviewedAll;
